<template>
  <ion-page>
    <ion-header>
      <ion-toolbar :color="sampleObj.type=='singleocc'?'primary':'secondary'" style="--padding-end:0">
        <ion-buttons>
          <ion-button slot="start"  @click="readySample">
            <ion-icon :icon="closeOutline" slot="icon-only" />
          </ion-button>
          <span v-if="sampleObj.type!='subplot'">
            <div>{{sampleObj.type=='singleocc'?'Einzeleingabe: ':'Listeneingabe: '}}</div>
            <div style="font-size:.8rem">{{surveys[survey].title_short}}</div>
          </span>
          <span v-else>
            {{sampleObj.location_name}}
          </span>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
  <ion-content>
  <ion-fab v-if="work" vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button :color="fabColor" @click="addSample">
    <ion-icon v-if="sampleObj.type=='singleocc'" :icon="addOutline" />
    <ion-icon v-else :src="ios?'assets/add-flower-outline.svg':'data:image/svg+xml;base64,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'" />
    </ion-fab-button>
    <ion-fab-button :color="fabColor" @click="readySample">
      <ion-icon :icon="checkmarkDoneOutline"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <ion-fab vertical="bottom" horizontal="start" slot="fixed">
    <ion-fab-button :color="fabColor">
      <ion-icon :icon="ellipsisVerticalOutline"></ion-icon>
    </ion-fab-button>
    <ion-fab-list side="top">
      <ion-fab-button :color="fabColor" @click="deleteSmp">
        <ion-icon :icon="trashBinOutline"></ion-icon>
      </ion-fab-button>
      <ion-fab-button v-if="work" :color="fabColor" @click="cloneSample">
        <ion-icon :icon="copyOutline"></ion-icon>
      </ion-fab-button>
    </ion-fab-list>
  </ion-fab>
    <ion-item v-if="occ!='multi'">
      <ion-icon slot="start" :icon="flowerOutline" />
      <ion-icon v-if="work" slot="end" @click="pushSearch" :icon="chevronForwardOutline" class="detail-icon" />
      <span class="stacked-label-container">
        <div class="stacked-label">ART</div>
        <div class="attribute-value">{{occurrence.speciesName}} </div>
      </span>
    </ion-item>
    <div @click="mapClick" style="height:11rem">
      <LeafletMap
        :pointClick="false"
        :zoom="13" :offline="false" :controls="false" :mapid="String(sample)" @componentready="setComponent"/>
    </div>
    <ion-item v-if="sampleObj.xCentroid">
      <ion-icon slot="start" :icon="locationOutline" />
      <ion-icon v-if="work"  slot="end" :icon="reloadOutline" class="detail-icon" @click="refreshCoord" />
      <span class="stacked-label-container">
        <div class="stacked-label">Koordinaten (WGS84)</div>
        <div class="attribute-value" :style="sampleObj.blur>10?'color:red':''">
          {{`${sampleObj.yCentroid} N, ${sampleObj.xCentroid} E`}}
        </div>
        <div class="attribute-value" v-if="sampleObj.blur" :style="sampleObj.blur>10?'color:red':''">
          {{`${sampleObj.blur}m Unschärfe`}}
        </div>
      </span>
    </ion-item>
    <ion-item v-if="sampleObj.tk">
      <ion-icon slot="start" :src="ios?'assets/del-raster-outline.svg':'data:image/svg;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi43NDk5NSAzVjIxLjEzOTVNMyAxNy4yNTAxSDIxIiBzdHJva2U9IiM2NjY2NjYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkPSJNMTcuMjUwMSAzVjIxTTIxIDYuNzU0MjVIMi4yNTAxMiIgc3Ryb2tlPSIjNjY2NjY2IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+'" />
      <span class="stacked-label-container">
        <div class="stacked-label">{{storage.globalSettings.gridType==9?"Minutenfeld (QXY)":"Quadrant (QQQ)"}}</div>
        <div class="attribute-value">{{storage.globalSettings.gridType==9?projMinutes(Number(sampleObj.xCentroid),Number(sampleObj.yCentroid)):projTK(Number(sampleObj.xCentroid),Number(sampleObj.yCentroid))}}</div>
      </span>
    </ion-item>
    <ion-item v-if="occ!='multi'">
      <ion-icon slot="start" :icon="toggleOutline" />
      <span class="stacked-label-container">
        <div class="stacked-label">Vergebliche Suche</div>
        <div class="attribute-value">
          <ion-toggle :disabled="!work"
            @ionChange="occurrence.zero_abundance=='t'?occurrence.zero_abundance='f':occurrence.zero_abundance='t'"
            style="padding-inline:0"
            :checked="occurrence.zero_abundance=='t'">
          </ion-toggle>
        </div>
      </span>
    </ion-item>
    <ion-item v-if="occ!='multi'">
      <ion-icon slot="start" :icon="peopleOutline" />
      <span class="stacked-label-container">
        <div class="stacked-label">Standort verschleiern</div>
        <ion-select :disabled="!work" class="attribute-value" :value="occurrence.sensitivity_precision" @ionChange="occurrence.sensitivity_precision=$event.target.value" interface="popover">
          <ion-select-option :value="0">nein</ion-select-option>
          <ion-select-option :value="100">100m</ion-select-option>
          <ion-select-option :value="1000">1000m</ion-select-option>
          <ion-select-option :value="2000">2000m</ion-select-option>
          <ion-select-option :value="10000">10000m</ion-select-option>
        </ion-select>
      </span>
    </ion-item>
    <ion-item v-if="sampleObj.type!='subplot'">
      <ion-icon slot="start" :icon="pencilOutline" style="align-items:center"/>
      <ion-icon v-if="work"  slot="end" :icon="chevronForwardOutline" class="detail-icon" @click="openTextModal({type:'comment',attrName:'comment',text:'Aufnahmebeschreibung'}, sampleObj)" />
      <span class="stacked-label-container">
        <div class="stacked-label">Aufnahmebeschreibung</div>
        <div style="font-size:.9rem">{{sampleObj.comment}}</div>
      </span>
    </ion-item>
    <ion-item v-if="occurrence">
      <ion-icon slot="start" :icon="pencilOutline" style="align-items:center"/>
      <ion-icon v-if="work"  slot="end" :icon="chevronForwardOutline" class="detail-icon" @click="openTextModal({type:'comment',attrName:'comment',text:'Artbeschreibung'}, occurrence)" />
      <span class="stacked-label-container">
        <div class="stacked-label">Artbeschreibung</div>
        <div style="font-size:.9rem">{{occurrence.comment}}</div>
      </span>
    </ion-item>
    <ion-item @click="setDatetimeOpen(true, $event)">
      <ion-icon slot="start" :icon="timeOutline" />
      <span class="stacked-label-container">
        <div class="stacked-label">
          Datum
        </div>
        <div class="attribute-value">
          {{formatDate(sampleObj.date)}}
        </div>
      </span>
      <ion-icon v-if="work" slot="end" :icon="chevronForwardOutline" class="detail-icon" />
      <ion-popover
        :is-open="isDatetimeOpen"
        style="--offset-y:-3rem"
        @didDismiss="setDatetimeOpen(false)"
        :dismiss-on-select="false"
        :show-backdrop="true"
      ><ion-datetime
          :max="zonedTime(new Date())"
          :value="zonedTime(sampleObj.date)"
          @ionChange="sampleObj.date = utcTime($event.target.value)"
        ></ion-datetime>
      </ion-popover>
    </ion-item>
    <div v-for="(group, key) in filteredAttributes" :key="'g'+key">
      <ion-item-divider v-if="group.groupName">
        <ion-label>
          {{group.groupName}}
        </ion-label>
      </ion-item-divider>
      <div v-for="(attr, key) in group.attributes" :key="key">
        <span v-if="(work||(occOrSample(attr)[attr.attrName]&&!occOrSample(attr)[attr.attrName].length==0))
          &&(attr.sampleMethod==parentMethod||!attr.sampleMethod||!parentMethod)&&attr.controlType!='date'">
          <ion-item v-if="attr.controlType=='hierarchical_select'&&work">
            <ion-icon slot="start" :icon="listOutline" />
            <ion-icon v-if="work"  slot="end" :icon="chevronForwardOutline" class="detail-icon" @click="clickPicklist(attr.attributeType+attr.attrName, occ, null, 0)" />
            <ion-label position="stacked" class="stacked-label">{{attr.text}}</ion-label>
            <span v-for="(child, key) in occOrSample(attr)[attr.attrName]" :key="'child'+key" @click="clickPicklist(attr.attributeType+attr.attrName, occ, child.value, key+1)">
              {{child.text}}
              <i v-if="work" class="material-icons materialIcons">list</i></span>
              <Lock v-if="work" :attribute="attr" :valueObject="occOrSample(attr)"/>
          </ion-item>
          <ion-item v-else-if="attr.controlType=='checkbox_group'||attr.controlType=='listbox'">
            <ion-icon slot="start" :icon="listOutline" />
            <ion-icon v-if="work" slot="end" :icon="chevronForwardOutline" class="detail-icon" @click="clickPicklist(attr.attributeType+attr.attrName, occ)" />
            <ion-label position="stacked" class="stacked-label">{{attr.text}}</ion-label>
            <ion-input class="attribute-value" readonly v-for="(item, key) in occOrSample(attr)[attr.attrName]" :key="'item'+key" :value="textValues[attr.attributeType+attr.attrName][occOrSample(attr)[attr.attrName][key]]+(key+1==occOrSample(attr)[attr.attrName].length?'':', ')" />
            <Lock :attribute="attr" :valueObject="occOrSample(attr)"/>
          </ion-item>
          <ion-item v-else-if="attr.values.length>0">
            <ion-icon slot="start" :icon="listOutline" />
            <span class="stacked-label-container">
              <div class="stacked-label">{{attr.text}}</div>
              <div v-if="occOrSample(attr)[attr.attrName]" class="attribute-value">
                <Lock v-if="!(attr.controlType=='hierarchical_select')" :attribute="attr" :valueObject="occOrSample(attr)"/>
                {{occOrSample(attr)[attr.attrName] ? 
                textValues[attr.attributeType+attr.attrName][occOrSample(attr)[attr.attrName]] : ''}}
              </div>
            </span>
            <ion-icon v-if="work"  slot="end" @click="clickPicklist(attr.attributeType+attr.attrName, occ, null, -1)" :icon="chevronForwardOutline" class="detail-icon" />
          </ion-item>
          <ion-item v-else-if="attr.type=='B'">
            <ion-icon slot="start" :icon="toggleOutline" />
            <span class="stacked-label-container">
              <div class="stacked-label">{{attr.text}}</div>
              <div class="attribute-value">
                <ion-toggle :disabled="!work"
                  @ionChange="occOrSample(attr)[attr.attrName]=Math.abs(occOrSample(attr)[attr.attrName]-1)"
                  style="padding-inline:0"
                  :checked="occOrSample(attr)[attr.attrName]==1">
                </ion-toggle>
              </div>
            </span>
            <Lock :attribute="attr" :valueObject="occOrSample(attr)"/>
          </ion-item>
          <ion-item v-else>
            <ion-icon v-if="attr.text=='Kartierer'" slot="start" :icon="personOutline" />
            <ion-icon v-else slot="start" :icon="attr.type=='I'?cellularOutline:textOutline" />
            <span class="stacked-label-container">
              <div class="stacked-label">{{attr.text}}</div>
              <div v-if="occOrSample(attr)[attr.attrName]" style="font-size:.9rem">
                <Lock :attribute="attr" :valueObject="occOrSample(attr)"/>
                {{occOrSample(attr)[attr.attrName] ? occOrSample(attr)[attr.attrName] : ''}}
              </div>
            </span>
            <ion-icon v-if="work"  slot="end" :icon="chevronForwardOutline" @click="openTextModal(attr, occOrSample(attr))" class="detail-icon" />
          </ion-item>
        </span>
      </div>
    </div>
    <ion-item v-if="sampleObj.type=='plot'&&occurrencesArray.length>0" lines="none">
      <ion-icon @click="sortAlpha=!sortAlpha" :icon="filterOutline" slot="end" />
      <ion-label style="margin-bottom:0">
        <div class="small-title">
          {{distinctTaxa+" Arten"}}
        </div>
        <div class="small-title">
          {{occurrencesArray.length+" Beobachtungen"}}
        </div>
      </ion-label>
    </ion-item>
    <ion-list ref="list" style="padding-top:0">
      <transition-group name="vuelist" v-if="sampleObj.type=='plot'">
        <TaxonItem v-for="occurrence in occurrencesArray" :key="occurrence.id" :occurrence="occurrence" :sample="sampleObj"/>
      </transition-group>
    </ion-list>
    <span v-if="sampleObj.type!='subplot'">
      <Foto :obj=sampleObj text="LEBENSRAUM-AUFNAHMEN" :work="work"/>
    </span>
    <span v-if="occ!='multi'">
      <Foto :obj=occurrence text="ART-AUFNAHMEN" :work="work"/>
    </span>
    <br><br><br><br><br><br>
  </ion-content>
  </ion-page>
</template>

<script>
import { CONFIG } from '../helpers/config.js'
import LeafletMap from '../components/LeafletMap.vue'
import Foto from '../components/Foto.vue'
import Lock from '../components/Lock.vue'
import TextModal from '../components/TextModal.vue'
import TaxonItem from '../components/TaxonItem.vue'
import L from 'leaflet'
import { format, parseISO } from 'date-fns'
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz'
import storeMixin from '../mixins/store.js'
import utilsMixin from '../mixins/utils.js'
import { useRoute } from 'vue-router'
import { 
  IonContent,
  IonPage,
  IonToolbar,
  IonIcon, 
  IonItem, 
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonList,
  IonDatetime,
  IonToggle,
  IonPopover,
  IonInput,
  IonFab,
  IonFabButton,
  IonFabList,
  IonItemDivider,
  IonHeader,
  IonButtons,
  IonButton,
  modalController,
  isPlatform
} from '@ionic/vue'
import {
  chevronForwardOutline,
  checkmarkDoneOutline,
  addOutline,
  ellipsisVerticalOutline,
  trashBinOutline,
  copyOutline,
  shareSocialOutline,
  flowerOutline,
  pencilOutline,
  timeOutline,
  locationOutline,
  mapOutline,
  peopleOutline,
  listOutline,
  toggleOutline,
  textOutline,
  cellularOutline,
  personOutline,
  filterOutline,
  closeOutline,
  reloadOutline,
} from 'ionicons/icons'
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
let watchId
export default {
  components: {
    IonContent,
    IonPage,
    IonToolbar,
    IonIcon, 
    IonItem, 
    IonLabel, 
    IonSelect,
    IonSelectOption,
    IonList,
    IonPopover,
    IonInput,
    IonFab,
    IonFabButton,
    IonFabList,
    LeafletMap,
    Foto,
    Lock,
    TaxonItem,
    IonDatetime,
    IonToggle,
    IonItemDivider,
    IonHeader,
    IonButtons,
    IonButton,
  },
  inject: ['storage'],
  mixins: [storeMixin, utilsMixin],
  name: 'occurrence',
  data () {
    return {
      route: useRoute(),
      sample: useRoute().params.sample,
      occ: useRoute().params.occ,
      occurrence: {},
      sampleObj: this.storage.samples[useRoute().params.sample],
      map: null,
      mapComponent: null,
      chevronForwardOutline,
      checkmarkDoneOutline,
      addOutline,
      ellipsisVerticalOutline,
      copyOutline,
      trashBinOutline,
      shareSocialOutline,
      flowerOutline,
      pencilOutline,
      timeOutline,
      locationOutline,
      mapOutline,
      peopleOutline,
      listOutline,
      toggleOutline,
      textOutline,
      cellularOutline,
      personOutline,
      filterOutline,
      closeOutline,
      reloadOutline,
      parentMethod: null,
      isDatetimeOpen: false,
      popoverEvent: null,
      fabColor: null,
      sortAlpha: false,
      survey: localStorage.getItem('surveyIndicia'),
      userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      ios: isPlatform("ios")
    }
  },
  computed: {
    surveys: function () {
      return this.storage.globalSettings.surveys
    },
    work: function () {
      return  this.sampleObj.status=="In Bearbeitung"
    },
    filteredAttributes: function () {
      if (this.occ=="multi")
        return  this.storage.attributes.filter(group => group.groupName!="Angaben zur Artbeobachtung")
      else if (this.sampleObj.type=="singleocc")
        return this.storage.attributes
      else
        return this.storage.attributes.filter(group => group.groupName=="Angaben zur Artbeobachtung")
    },
    occurrencesArray: function () {
      const occurrencesA = []
      if (this.occ=="multi") {
        for (const sample of this.sampleObj.samples) {
          const key = Object.keys(this.storage.samples[sample].occurrences)[0]
          occurrencesA.push(Object.assign(this.storage.samples[sample].occurrences[key],{date:this.storage.samples[sample].date}))
        }
      }
      if (!this.sortAlpha)
        return occurrencesA.sort((a, b) => {
          if(a.date > b.date) { return -1 }
          if(a.date < b.date) { return 1 }
          return 0
        })
      else
        return occurrencesA.sort((a, b) => {
          if(a.speciesName > b.speciesName) { return 1 }
          if(a.speciesName < b.speciesName) { return -1 }
          return 0
        })
    },
    distinctTaxa: function () {
      let obj = {}
      for (const occ of this.occurrencesArray) {
        obj[occ.speciesId] = null
      }
      return Object.keys(obj).length
    }
  },
  created() {
    if (this.sampleObj.type=="singleocc")
      this.fabColor = "primary"
    else
      this.fabColor = "secondary"
    this.occurrence = this.sampleObj.occurrences[this.occ]
    this.indexTextValues()
  },
  ionViewDidEnter() {
    console.log("ionViewDidEnter")
    this.refreshView()
    if (typeof this.sampleObj.xCentroid === "undefined") {
      watchId = navigator.geolocation.watchPosition(this.successCallback, this.errorCallback, {enableHighAccuracy: true, maximumAge: 0, timeout: 20000})
    }
    this.drawMap()
  },
  ionViewDidLeave() {
    console.log("ionViewDidLeave")
    navigator.geolocation.clearWatch(watchId)
  },
  methods: {
    zonedTime(date) {
      const zonedTime = utcToZonedTime(date, this.userTimeZone)
      return format(zonedTime, "yyyy-MM-dd'T'HH:mm:ss", { timeZone: this.userTimeZone })
    },
    utcTime(date) {
      const utcTime = zonedTimeToUtc(date, this.userTimeZone)
      return utcTime.toISOString()
    },
    setComponent(component) {
      this.mapComponent = component
      this.map = component.map
    },
    drawMap() {
      if (this.map) {
        this.mapComponent.configMapView()
        this.map.remove()
        console.log("map.remove")
        this.mapComponent.layers = []
      }
      this.mapComponent.initMap()
      let samples = []
      if (this.sampleObj.parentId)
        samples = this.storage.samples[this.sampleObj.parentId].samples
      else if (this.sampleObj.type=="singleocc")
        samples.push(this.sampleObj.id)
      if (this.sampleObj.type!="plot")
        this.occsMarkers(samples, this.mapComponent, this.sampleObj.id)
      if (this.sampleObj.xCentroid) {
          this.map.setView([this.sampleObj.yCentroid, this.sampleObj.xCentroid], 16)
      }
      if(this.occ=="multi"&&(this.sampleObj.polyline.length==1||(this.sampleObj.polyline.length==0&&this.sampleObj.xCentroid))) {
        samples = this.sampleObj.samples
        this.occsMarkers(samples, this.mapComponent, null)
        this.mapComponent.polygon = L.circle([this.sampleObj.yCentroid, this.sampleObj.xCentroid], {
          radius: this.sampleObj.blur?this.sampleObj.blur/2:10,
          color: 'orange',
          fillOpacity: 0,
          fillColor : 'white'})
          .addTo(this.map)
      }
      if (this.sampleObj.polyline.length>1) {
        samples = this.sampleObj.samples
        this.occsMarkers(samples, this.mapComponent, null)
        this.mapComponent.polygon = L[this.sampleObj.geoType](this.sampleObj.polyline, {weight: 2}).addTo(this.map)
      }
      document.getElementsByClassName( 'leaflet-control-attribution' )[0].style.display = 'none'
    },
    refreshView() {
      this.sample = this.route.params.sample
      this.sampleObj = this.storage.samples[this.sample]
      this.parentMethod = this.sampleObj.type=="subplot"?this.storage.samples[this.sampleObj.parentId][136]:null
      console.log(this.parentMethod+ "refreshView")
      this.occ = this.route.params.occ
      this.occurrence = this.sampleObj.occurrences[this.occ]
    },
    successCallback(position) {
      let tkTxt
      this.sampleObj.blur = position.coords.accuracy.toFixed(0)
      console.log("blur: "+this.sampleObj.blur)
      this.sampleObj.xCentroid = position.coords.longitude.toFixed(5)
      this.sampleObj.yCentroid = position.coords.latitude.toFixed(6)
      this.drawMap()
      if (position.coords.accuracy<=5) {
        navigator.geolocation.clearWatch(watchId)
        let gridType = this.storage.globalSettings.gridType
        if (gridType==9)
          gridType = 0
        if (this.storage.globalSettings.gridType==9)
          tkTxt = this.projMinutes(Number(this.sampleObj.xCentroid), Number(this.sampleObj.yCentroid))
        else 
          tkTxt = this.projTK(Number(this.sampleObj.xCentroid), Number(this.sampleObj.yCentroid))
        if (this.storage.globalSettings.gridChange&&this.storage.lastTK&&tkTxt.slice(0, tkTxt.length-gridType)!=
          this.storage.lastTK.slice(0, tkTxt.length-gridType))
          CONFIG.headerAlert("Wechsel des in den Optionen ausgewählten Rasterfeldtyps seit letzter Artbeobachtung", "", [{text:'OK',role:'ok'}])
        this.sampleObj.tk = this.storage.lastTK = tkTxt
      } 
    },
    errorCallback(error) {
      console.log(error)
      switch(error.code) {
        case error.TIMEOUT:
          console.log("TIMEOUT")
          navigator.geolocation.clearWatch(watchId)
        break
        case error.POSITION_UNAVAILABLE:
          console.log("POSITION_UNAVAILABLE")
          navigator.geolocation.clearWatch(watchId)
        break
        case error.PERMISSION_DENIED:
          console.log("PERMISSION_DENIED")
          navigator.geolocation.clearWatch(watchId)
        break
      }
    },
    occOrSample(attr) {
      if (attr.attributeType=="S") {
        return this.sampleObj
      }
      else {
        return this.occurrence
      }
    },
    mapClick() {
      if (this.sampleObj.status=='In Bearbeitung') {
        if (this.occ=="multi")
          this.$router.push({name: 'map', params: {id: this.sample}})
        else
          this.$router.push({name: 'mapocc', params: {sampleId: this.sample, occId: this.occ}})
      }
    },
    clickPicklist(attrName, occ, parent, index) {
      this.$router.push({ name: 'radiolist', params: { 
        attribute: attrName,
        id: this.sample, occ: occ, parent: parent, index: index}})
    },
    pushSearch () {
      this.$router.push({name: 'speciessearch', params: {sample: this.sample, occ: this.occ}})
    },
    testRules() {
      let error = this.checkForm("S", this.sampleObj)
      if (error.length>0) {
        CONFIG.headerAlert("Eingabefehler", error, [{text:'OK'}])
        return false
      }
      else if (this.sampleObj.type!="plot") {
        let error = this.checkForm("O", this.occurrence)
        if (error.length>0) {
        CONFIG.headerAlert("Eingabefehler", error, [{text:'OK'}])
          return false
        }
      }
      return true
    },
    readySample() {
      if (this.work) {
        if (this.testRules()) {
          if (this.sampleObj.type=="subplot")
            this.$router.push({name: 'singleocc', params: {sample: this.sampleObj.parentId, occ: "multi"}})
          else {
            this.$router.replace({name: 'funde'})
          }
        }
      }
      else
        this.$router.replace({name: 'funde'})
    },
    buildSample() {
      /*
      let arr = []
      for (const sample of Object.values(this.storage.samples)) {
        if (sample.parentId==this.sample)
          arr.push(sample.id)
      }
      this.storage.samples[this.sample].samples = arr
      */
    },
    addSample() {
      if (this.testRules()) {
        let sample, occ, route
        route = "speciessearch"
        if (this.sampleObj.type=="plot") {
          sample = this.sample
          occ = "subsample"
        }
        else if (this.sampleObj.type=="subplot") {
          sample = this.sampleObj.parentId
          occ = "subsample"
        }
        else {
          sample = "new"
          occ = "new"
        }
        this.$router.push({name: route, params: {sample: sample, occ: occ}})
      }
    },
    cloneSample() {
      function cloneIndicia(obj, that, parentId) {
        let clone = {id: CONFIG.UUID()}
        for (const [key, value] of Object.entries(obj)) {
          if (key == "parentId") {
            if (parentId) {
              clone.parentId = parentId
            }
            else {
              that.storage.samples[value].samples.push(clone.id)
              clone.parentId = value
            }
          }
          else if (key == "sampleId")
            clone.sampleId = parentId
          else if (key == "date") {
            if (parentId)
              clone.date = "1990-01-01"
            else
              clone.date = value
          }
          else if (key == "occurrences") {
            clone.occurrences = {}
            for (const occurrence of Object.values(value)) {
              let occ = cloneIndicia(occurrence, that, clone.id)
              clone.occurrences[occ.id] = occ
            }
          }
          else if (key == "fotos")
            clone.fotos = {}
          else if (key == "samples") {
            clone.samples = []
            for (const sampleId of value) {
              let subSample = cloneIndicia(that.storage.samples[sampleId], that, clone.id)
              that.storage.samples[subSample.id] = subSample
              clone.samples.push(subSample.id)
            }
          }
          else if (key!="id")
           clone[key] = value
        }
        return clone
      }
      if (this.testRules()) {
        let sample = cloneIndicia(this.sampleObj, this, null)
        this.storage.samples[sample.id] = sample
        this.readySample()
      }
    },
    deleteSmp() {
      this.deleteSample(this.sample).then((result) => {
        if (result=="OK") {
          if (this.sampleObj.type=="singleocc"||this.sampleObj.type=="plot")
            this.$router.push({name: 'funde'})
          else
            this.$router.push({name: 'singleocc', params: {sample: this.sampleObj.parentId, occ: "multi"}})
        }
      })
    },
    formatDate(value) {
      return format(parseISO(value), 'dd.MM.yyyy kk:mm')    
    },
    setDatetimeOpen(state, ev) {
      this.popoverEvent = ev
      this.isDatetimeOpen = state
    },
    async openTextModal(attr, valueObject) {
      const modal = await modalController
        .create({
          keyboardClose: false,
          component: TextModal,
          componentProps: {
            data: {valueObject: valueObject, attr: attr}
          },
        })
      await modal.present()
      document.getElementById("editRef").setFocus()
    },
    refreshCoord() {
      watchId = navigator.geolocation.watchPosition(this.successCallback, this.errorCallback, {enableHighAccuracy: true, maximumAge: 0, timeout: 20000})
    },
  },
}
</script>
<style scoped>
ion-fab-button {
  margin-top: 1rem;
}
.detail-icon {
  margin-right: .8rem;
  margin-left: .6rem;
}
ion-item::part(native) {
  align-items: center;
}
.small-title {
  font-size:1rem;
  margin-bottom:.2rem;
}
.stacked-label-container {
  display:flex;
  flex-direction:column;
  padding-top:.4rem;
  padding-bottom: .4rem;
  align-self:center;
}
.stacked-label {
  font-size: 1.1rem;
}
.attribute-value {
  display: flex;
  font-size: .9rem;
  white-space: nowrap;
  text-overflow: ellipsis;

}
ion-item {
  --min-height: 2.5rem;
}
ion-icon {
  margin-top: 0;
  margin-bottom: 0;
}
</style>